import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=2363d4f3&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"
import style0 from "./Messages.vue?vue&type=style&index=0&id=2363d4f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363d4f3",
  null
  
)

export default component.exports